<section class="planes pt-3">
  <app-banner-section-planes></app-banner-section-planes>
  <div class="container">
    <div class="row">
      <ng-container *ngFor="let post of posts">
        <div class="col-lg-4 col-md-6 mb-4" *ngIf="!post.acf.portada.plan_oculto && !post.acf.portada.promo">
          <div class="card h-100 border-0 shadow-sm d-flex flex-column">
            <div class="card-body d-flex flex-column">
              <div class="plan-icon mb-3">
                <img *ngIf="post.acf.portada.imagen_fondo_mobile" [src]="post.acf.portada.imagen_fondo_mobile"
                  alt="Icono del plan" class="img-fluid w-100" />
              </div>
              <div class="p-4 flex-grow-1">
                <h3 class="card-title mb-3" [innerHTML]="post.acf.portada.titulo"></h3>
                <p class="card-text text-muted mb-4" [innerHTML]="post.acf.portada.bajada"></p>
                <ul class="list-unstyled mb-4 caracteristicas">
                  <li *ngFor="let caracteristica of post.acf.portada.caracteristicas"
                    class="d-flex align-items-start mb-4">
                    <img *ngIf="caracteristica.icono" [src]="caracteristica.icono" alt="" class="mr-2">
                    <span [innerHTML]="caracteristica.texto"></span>
                  </li>
                </ul>
              </div>
              <div class="button-plan mt-auto mb-4 text-center ">
                <button class="btn" (click)="contratar(post.slug)" [routerLink]="['/planes', post.slug]">
                  CONOCER MÁS SOBRE ESTE PLAN
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<!-- Sección de Promos -->
<section class="promos py-5 bg-light">
  <div class="container">
    <div class="row text-center mb-4">
      <div class="col-12 title-promos">
        <h2>Todos los planes incluyen beneficios pensados para cuidarte más y mejor.</h2>
        <p>No importa cuál elijas, estos beneficios ya vienen con tu plan.
          Accedé desde el primer día, sin costos extra ni gestiones adicionales.</p>
      </div>
    </div>
    <div class="row">
      <ng-container *ngFor="let post of posts">
  <div class="col-lg-6 col-md-12 mb-4" *ngIf="!post.acf.portada.plan_oculto && post.acf.portada.promo">
    <div class="card h-100 border-0 shadow-sm promo-card radius-25 d-flex flex-column">
      <div class="row no-gutters flex-grow-1 h-100">
        <div class="col-md-6 col-12">
          <img *ngIf="post.acf.portada.imagen_fondo_mobile" [src]="post.acf.portada.imagen_fondo_mobile"
            alt="Imagen de promo" class="card-img w-100 h-md-100 d-block" 
            style="object-fit: cover;" 
            [style.height.px]="'100%'"
             />
        </div>
        <div class="col-md-6 col-12 d-flex flex-column">
          <div class="card-body d-flex flex-column h-100 p-4">
            <h4 class="card-title mb-3" [innerHTML]="post.acf.portada.titulo"></h4>
            <p class="card-text flex-grow-1 text-muted" [innerHTML]="post.acf.portada.bajada"></p>
            <div class="mt-auto">
              <button class="btn" (click)="contratar(post.slug)" [routerLink]="['/planes', post.slug]">
                <span [innerHTML]="post.acf.boton.nombre"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
    </div>
  </div>
</section>